export const TREE_LEVEL_COLORS = [
    'red',
    'green',
    'blue',
    'magenta',
];
